<template>
  <div class="full-height d-flex flex-column ">

    <pc-header activeIndex="donate"></pc-header>
    <div class="container overflow-hidden">
      <div class="row">
        <div class="col-12">
          <h4 class="mt-5">Make a Donation</h4>
          <div class="text-secondary">Here you can help us with further development of new and existing products.</div>
          <el-form ref="form" class="mt-4" label-width="120px" style="max-width: 500px">
            <div class="block">
              <span class="demonstration">Select or enter custom amount to donate</span>
              <el-slider
                  class="mb-4"
                  v-model="amount_of_donation"
                  :min="1"
                  :max="200"
                  :marks="marks"
                  >
              </el-slider>
            </div>
            <el-form-item label="Amount" style="max-width: 300px">
              <el-input type="number" class="input-amount" v-model="amount_of_donation">
                <template slot="append">$</template>
              </el-input>
            </el-form-item>
            <el-form-item label="Attach message">
              <el-input type="textarea" placeholder="(optional)" v-model="donation_message">
                <template slot="append">$</template>
              </el-input>
            </el-form-item>
            <el-form-item>

            </el-form-item>
            <el-button type="primary" class="donate__button" v-loading="loading" :disabled="!amount_of_donation" @click="startDonation">
              Donate ${{amount_of_donation}} Now
            </el-button>

          </el-form>
        </div>
        <div class="row mt-5">
          <div class="col-12">
            <h5 class="mb-3">Support Through Cryptocurrency:</h5>
            <p class="text-secondary mb-4">
              We welcome contributions via digital currencies to help sustain and grow this open source project.
              Every donation helps maintain and improve PyCrunch for the community.
            </p>
          </div>
        </div>
        <pc-crypto-donation/>
      </div>
    </div>
    <pc-footer></pc-footer>
  </div>
</template>

<script>
import PcHeader from '../components/pc-header.component'
import {mapState} from 'vuex'
import {track} from '../ga-events'
import PcFooter from '../views/PcFooter'
import axios from 'axios'
import config from '../config'
import QRCode from "qrcode";
import PcCryptoDonation from "@/views/PcCryptoDonation.vue";

export default {
    name: 'sing-in',
    components: {
      PcCryptoDonation,
      PcFooter,
      PcHeader,
    },
    data () {
      return {
        loading: false,
        amount_of_donation: 10,
        donation_message: '',
        marks: {
          1: '1$',
          20: '20$',
          50: '50$',
          100: '100$',
          200: '200$',
        }
      }
    },
    computed: {
      ...mapState(['count']),
    },
    methods: {

      my_way_for_pay: function (wayforpay, response) {
        let self = this
        wayforpay.run({
            merchantAccount: response.data.merchant_account,
            merchantDomainName: response.data.merchant_domain_name,
            authorizationType: 'SimpleSignature',
            merchantSignature: response.data.signature,
            orderReference: response.data.order_reference,
            orderDate: response.data.order_date,
            amount: response.data.product_price,
            // amount: 0,
            currency: response.data.currency,
            productName: response.data.product_name,
            productPrice: response.data.product_price,
            productCount: '1',
            clientEmail: '',
            serviceUrl: response.data.service_url,
            // regularOn: 1,
            // regularMode: 'monthly',
            // dateNext: '29.08.2019',
            // requestType: 'VERIFY',
            // theme : "bindcard"

            // straightWidget: true,

            // clientPhone: "380631234567",
            // language: "UA"
          },
          response => {
            // on approved
            this.$alert('Thank you for donation!', 'Payment approved', {
              confirmButtonText: 'OK',
              callback: action => {
                this.$message({
                  type: 'info',
                  message: 'Payment approved',
                })
                // this.reload_profile()
              },
            })
          },
          response => {
            // on declined
            this.$alert(response, 'Payment declined', {
              confirmButtonText: 'OK',
              callback: action => {
                this.$message({
                  type: 'info',
                  message: 'Payment declined',
                })
                // this.reload_profile()

              },
            })
          },
          response => {
            // on pending or in processing
            let processingMessage = 'Thank you for donation! Payment is still processing and may take up to 10 minutes to verify.'
            this.$alert(processingMessage, 'Payment processing', {
              confirmButtonText: 'OK',
              callback: action => {
                this.$message({
                  type: 'info',
                  message: processingMessage,
                })
                // this.reload_profile()
              },
            })
          },
        )
      },

      async startDonation () {
        track('donations', 'will_start_donation', this.amount_of_donation)

        var wayforpay = new Wayforpay()
        let response = await axios.post(config.api_root + '/api/donate-now', {
          amount_of_donation: Number(this.amount_of_donation),
          donation_message: this.donation_message,
        })
        this.my_way_for_pay(wayforpay, response)
      },
    },
  }
</script>

<style scoped>
  .full-height {
    min-height: 100vh;
    flex-direction: column;
  }
  @media (max-width: 577px) {
    .donate__button {
      width: 100%;
    }
  }

</style>
<style>
  /* Chrome, Safari, Edge, Opera */
  .input-amount input::-webkit-outer-spin-button,
  .input-amount input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* this is for Firefox */
  .input-amount input[type=number] {
    -moz-appearance: textfield;
  }



</style>